import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Button, Modal, Text } from '@sendible/design-system/src';

type DeleteReportModalProps = {
  reportName: string;
  onDelete: () => Promise<void>;
  onCancel: () => void;
};

export const DeleteReportModal = ({ reportName, onDelete, onCancel }: DeleteReportModalProps) => {
  const [isDeleting, setIsDeleting] = useState(false);
  const { t } = useTranslation('reports');

  const handleDelete = async () => {
    setIsDeleting(true);

    try {
      await onDelete();
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      close={onCancel}
      customClass="global-modal"
      headingTitle={t('new_reports_delete_modal_heading') as string}
      testId="delete-report-modal"
      variation="medium"
      ariaCloseLabel={t('new_reports_delete_modal_close_label') as string}
      footerContent={
        <Box
          fullWidth
          contentJustify="flex-end"
          horizontalGap="s8"
        >
          <Button
            onClick={onCancel}
            label={t('new_reports_delete_modal_cancel') as string}
            size={16}
            variation="outline"
            autoFocus
          />
          <Button
            appearance="danger"
            onClick={handleDelete}
            label={t('new_reports_delete_modal_delete') as string}
            isLoading={isDeleting}
            size={16}
            variation="fill"
          />
        </Box>
      }
    >
      <Text>{t('new_reports_delete_modal_body', { name: reportName })}</Text>
    </Modal>
  );
};
